
import {
  RevHorizontalSeries,
  RevHorizontalSeriesItem,
  icons,
} from '@backmarket/design-system'
import { mapGetters } from 'vuex'

import { PAYMENT_ADVERTISING_TYPES } from '@payment'

import {
  deliveryItem,
  paymentItem,
  satisfactionItem,
  warrantyItem,
} from '../../helpers/trust'

import translations from './TrustList.translations'

export default {
  components: {
    RevHorizontalSeriesItem,
    RevHorizontalSeries,
  },
  props: {
    variant: {
      type: String,
      required: true,
      validator: (value) =>
        Object.values(PAYMENT_ADVERTISING_TYPES).includes(value),
    },
    ratings: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    translations: () => translations,
    ...mapGetters({
      coolingOffDays: 'config/coolingOffDays',
      paymentMethods: 'countryConfig/paymentMethods',
      warrantyDuration: 'config/warrantyDuration',
    }),

    payment() {
      return paymentItem({
        paymentAdvertisingType: this.variant,
        paymentMethods: this.paymentMethods,
        ratings: this.ratings,
      })
    },

    satisfaction() {
      return satisfactionItem({ days: this.coolingOffDays })
    },

    delivery() {
      return deliveryItem()
    },

    warranty() {
      return warrantyItem({
        warrantyDuration: this.warrantyDuration,
      })
    },
  },
  methods: {
    iconComponent: (icon) => {
      return icons[icon]
    },
    isIconFromDS(icon) {
      return Object.keys(icons).includes(icon)
    },
    getStickerProps({ icon }) {
      if (this.isIconFromDS(icon)) return { icon: this.iconComponent(icon) }

      return {
        imageSrc: this.$static(icon),
      }
    },
  },
}
